import React from 'react';
import { ViolationListHeaderStyle } from './ViolationListView.styles';

const ViolationListHeaderComponent: React.FC = () => {
    return (
        <ViolationListHeaderStyle>
            <span className="col col-menu" title=""></span>
            <span className="col col-type" title="Type">
                Type
            </span>
            <span className="col col-cargo-nr" title="Cargo #">
                Cargo #
            </span>
            <span className="col col-description" title="Description">
                Description
            </span>
            <span className="col col-voyage" title="Voyage">
                Voyage
            </span>
            <span className="col" title="Port">
                Port
            </span>
            <span className="col" title="Berth">
                Berth
            </span>
            <span className="col col-tank" title="Tank">
                Tank
            </span>
            <span className="col col-tank" title="Adjacent tank">
                Adjacent tank
            </span>
            <span className="col col-accepted-by" title="Accepted by">
                Accepted by
            </span>
            <span className="col col-date-time" title="Accepted UTC">
                Accepted UTC
            </span>
        </ViolationListHeaderStyle>
    );
};

export default ViolationListHeaderComponent;
